/**
 * 功能描述：消息常量定义 <br>
 * 〈〉
 * @Author CHU
 * @Date 16:30 2021/2/19
 * @Version 1.0.0
 **/

// 提示标题
export const WARN_MESSAGE_TITLE = "温馨提示";

//
export const NOTICE_CHOICE_DELETE_ITEMS = "请选择需要删除的项";
